module.exports = __webpack_public_path__ + "img/12.90643891.svg";